import React, { memo, useCallback, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Button, Fade, FormGroup, Grid } from '@material-ui/core'
import { SortableContainer } from 'react-sortable-hoc'
import AddCircle from '@v4/components/common/FAIcons/Light/AddCircle'
import { FLEX } from '@v4/constants/quiz'
import OptionItem from '../OptionItem'
import useStyles from './OptionList.styled'

const OptionList = ({
	className,
	items,
	justify,
	multiple,
	showLabels,
	editable,
	draggable,
	selectedOptions,
	questionId,
	pending,
	imageFit,
	answersPerRow,
	invertColors,

	onAdd,
	onDelete,
	onLabelEdit,
	onClick,
}) => {
	const classes = useStyles({ justify })

	const gridLaptopSize = justify === FLEX.START ? 3 : 12
	const gridMobileSize = justify === FLEX.START ? 6 : 12

	const [focusedIndex, setFocusedIndex] = useState(null)

	const size = _.size(items)

	const handleAdd = useCallback(() => {
		setFocusedIndex(size)
		onAdd?.()
	}, [onAdd, size])

	return (
		<FormGroup className={clsx(className, 'q-image-group')}>
			<Grid container justify={justify} className={clsx(className, classes.root, 'q-image-grid', className)}>
				{_.map(items, ({ id, temporary_id: temporaryId, option, asset }, index) => {
					const optionId = temporaryId || id

					return (
						<Fade key={optionId} in timeout={index * 50 + 300}>
							<OptionItem
								key={optionId}
								id={optionId}
								imageFit={imageFit}
								answersPerRow={answersPerRow}
								multiple={multiple}
								questionId={questionId}
								index={index}
								label={option}
								asset={asset}
								showLabels={showLabels}
								editable={editable}
								checked={!!selectedOptions[optionId]}
								deletable={editable}
								draggable={draggable}
								pending={pending}
								loading={pending && selectedOptions[optionId] && !multiple}
								useDragHandle
								onLabelEdit={onLabelEdit}
								onDelete={onDelete}
								onClick={onClick}
								autoFocus={focusedIndex === index}
								placeholder={`Answer ${index + 1}`}
								invertColors={invertColors}
							/>
						</Fade>
					)
				})}
				{editable && (
					<Grid
						className={clsx(classes.addButtonWrapper, 'q-image-button-container')}
						item
						xs={gridMobileSize}
						sm={gridMobileSize}
						md={gridLaptopSize}
						lg={gridLaptopSize}
					>
						<Button
							startIcon={<AddCircle />}
							classes={{ root: classes.addButton, startIcon: classes.icon }}
							variant="text"
							onClick={handleAdd}
						>
							Add answer
						</Button>
					</Grid>
				)}
			</Grid>
		</FormGroup>
	)
}

OptionList.propTypes = {
	pending: PropTypes.bool,
	items: PropTypes.array,
	selectedOptions: PropTypes.object,
	withEdition: PropTypes.bool,
	onClick: PropTypes.func,
	onLabelEdit: PropTypes.func,
	onAdd: PropTypes.func,
	onDelete: PropTypes.func,
	className: PropTypes.string,
	draggable: PropTypes.bool,
	justify: PropTypes.string,
	showLabels: PropTypes.bool,
	editable: PropTypes.bool,
	questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	draggingId: PropTypes.string,
	imageFit: PropTypes.string,
	multiple: PropTypes.bool,
	answersPerRow: PropTypes.number,
	invertColors: PropTypes.bool,
}

export default memo(SortableContainer(OptionList))
